<template>
	<!-- 详情页vr头 -->
	<div class="dpubtop_warp">
		<!-- 遮罩层 -->
		<div class="popContainer" v-if="isShowzzc">
			<!-- vr申请展示 -->
			<div class="sq_ewm">
				<div class="sq_ewm_title">VR申请</div>
				<div class="gb_sqewm" @click="gb_SQ">
					<img src="../../imges/dpubtop/gbX.png">
				</div>

				<div class="from_sq">
					<el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign">
						<el-form-item label="单位名称" class="dwmc_warp">
							<el-input v-model="formLabelAlign.dbname"></el-input>
						</el-form-item>
						<el-form-item label="联系人" class="lxr_warp">
							<el-input v-model="formLabelAlign.name"></el-input>
						</el-form-item>
						<el-form-item label="职务" class="zw_warp">
							<el-input v-model="formLabelAlign.zw"></el-input>
						</el-form-item>
						<el-form-item label="手机" class="zw_warp">
							<el-input v-model="formLabelAlign.phone"></el-input>
						</el-form-item>
						<el-form-item label="电话" class="zw_warp">
							<el-input v-model="formLabelAlign.tel"></el-input>
						</el-form-item>
						<el-form-item label="邮箱" class="zw_warp">
							<el-input v-model="formLabelAlign.email"></el-input>
						</el-form-item>
						<el-form-item label="展示选项" class="dwmc_warp">
							<!-- <el-checkbox v-model="formLabelAlign.VRZT">VR展厅</el-checkbox> -->
							<!-- <el-checkbox v-model="formLabelAlign.VRDT">VR地图</el-checkbox> -->
							<el-checkbox-group v-model="formLabelAlign.zhanshi">
								<el-checkbox label="VR全景展示"></el-checkbox>
								<el-checkbox label="船海地图"></el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item label="添加链接" class="dwmc_warp">
							<el-input v-model="formLabelAlign.link"></el-input>
						</el-form-item>
						<el-form-item style="margin-top:40px;">
							<el-button style="width:180px;font-size:1.1rem;background:red;border:none;" type="primary"
								@click="submitVRsq()">立即申请</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<!-- 遮罩层 -->
		<div class="popContainer" v-if="isShowSQ">
			<!-- 制作 -->
			<div class="sq_ewm">
				<div class="sq_ewm_title">VR申请</div>
				<div class="gb_sqewm" @click="gb_sqzz">
					<img src="../../imges/dpubtop/gbX.png">
				</div>
				<div class="from_sq">
					<el-form :label-position="labelPosition" label-width="120px" :model="sqzzform">
						<el-form-item label="单位名称" class="dwmc_warp">
							<el-input v-model="sqzzform.unitName"></el-input>
						</el-form-item>
						<el-form-item label="联系人" class="lxr_warp">
							<el-input v-model="sqzzform.contacts"></el-input>
						</el-form-item>
						<el-form-item label="职务" class="zw_warp">
							<el-input v-model="sqzzform.userPost"></el-input>
						</el-form-item>
						<el-form-item label="手机" class="zw_warp">
							<el-input v-model="sqzzform.phone"></el-input>
						</el-form-item>
						<el-form-item label="电话" class="zw_warp">
							<el-input v-model="sqzzform.telephone"></el-input>
						</el-form-item>
						<el-form-item label="邮箱" class="zw_warp">
							<el-input v-model="sqzzform.email"></el-input>
						</el-form-item>
						<el-form-item label="地址" class="zw_warp">
							<el-input v-model="sqzzform.Address"></el-input>
						</el-form-item>
						<el-form-item style="margin-top:40px;">
							<el-button style="width:180px;font-size:1.1rem;background:red;border:none;" type="primary"
								@click="submitVRsq()">立即申请</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<img style="width: 900px;height: 400px;" src="../../imges/dpubtop/qydq1.png" alt="" @click="kkxx" v-if="xxkk">
		<div class="vr_hef" v-if="qwq">
			<iframe width="900px" height="400px" src="http://www.expoon.com/e/42p6mmx4zgr/"></iframe>
		</div>
		<div class="goto_index">
			<router-link class="qwe_warp" tag="div" to="/Vrshow" style="margin-left: 9.5%;">
				<img src="../../imges/dpubtop/vrzt.png" alt="">
				<div>VR展厅</div>
			</router-link>
			<router-link class="qwe_warp" tag="div" to="/Vrmap" style="margin-left: 31.8%;">
				<img src="../../imges/dpubtop/vrdt.png" alt="">
				<div>船海地图</div>
			</router-link>
			<div class="qwe_warp" style="margin-left: 53.8%;" @click="vrsqKF">
				<img src="../../imges/dpubtop/sqzs.png" alt="">
				<div>申请展示</div>
			</div>
			<div class="qwe_warp" style="margin-left: 77.8%;" @click="sqzzqKF">
				<img src="../../imges/dpubtop/sqzz.png" alt="">
				<div>申请制作</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				qwq: false,
				xxkk: true,
				// 标志符
				labelPosition: 'left',
				isShowzzc: false,
				isShowSQ: false,
				init_gd_01: 0,
				// 申请二维码展示
				formLabelAlign: {
					uid: 0,
					unitName: '', //单位名称
					contacts: '', //联系人
					userPost: '', //职务
					phone: '', //手机号
					telephone: '', //电话
					email: '', //邮箱
					zhanshi: [],
					linkAddress: '', //添加链接
					VRZT: true, //vr展厅
					VRDT: true //vr地图
				},
				sqzzform: {
					unitName: '', //单位名称
					contacts: '', //联系人
					userPost: '', //职务
					phone: '', //手机号
					telephone: '', //电话
					email: '', //邮箱
					Address: '', //添加链接
				}
			}
		},
		methods: {
			kkxx() {
				this.qwq = true
				this.xxkk = false
			},
			// vr申请
			gb_SQ() {
				this.isShowzzc = false
			},
			vrsqKF() {
				this.isShowzzc = true
			},
			submitVRsq() {
				
				if (this.formLabelAlign.email == '') {
					this.$message.error("邮件地址不能为空");
					return;
				}
				
				if (
					!/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
						this.formLabelAlign.email
					)
				) {
					this.$message.error("邮箱格式不正确");
					return;
				}
				
				
				const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				if (this.formLabelAlign.phone == '' || this.formLabelAlign.phone.length <= 10 || !reg.test(this.formLabelAlign.phone)) {
					this.$message({
						message: "请填写正确的手机号！！",
					});
					return;
				} 
				
				
				let that = this;
				const loginInfo = JSON.parse(window.localStorage.getItem('user') || null)
				if (!loginInfo) {
					that.$alert('请登录', '提示', {
						confirmButtonText: '确定',
					});
					this.$router.replace('/login')
					return false;
				}
				this.formLabelAlign.uid = String(loginInfo.value.id)
				this.$axios({
					headers: {
						'Authorization': this.$storage.getItem("token")
					},
					url: 'https://admin.shipoe360.com/api/picture/vrzs',
					method: "post",
					params: this.formLabelAlign
				}).then(res => {
					that.$alert(res.data.msg, '提示', {
						confirmButtonText: '确定',
					});
				})
			},
			// 申请制作
			gb_sqzz() {
				this.isShowSQ = false
			},
			sqzzqKF() {
				this.isShowSQ = true
			},
			submitsqzz() {
				console.log(this.sqzzform)
			},

		}
	}
</script>

<style scoped>
	.dpubtop_warp::after {
		content: '';
		display: block;
		clear: both;
	}

	.dpubtop_warp {
		background-color: #fff;
		padding: 8px;
		box-shadow: #6e6e6e 0px 0px 10px;
	}

	.vr_hef {
		float: left;
		width: 900px;
		height: 400px;
	}

	.goto_index {
		position: relative;
		float: right;
		width: 270px;
		height: 400px;
		background: url('../../imges/dpubtop/bg@3x1.png') no-repeat;
		background-size: 100% 100%;
	}

	.goto_index .qwe_warp {
		position: absolute;
		bottom: 30px;
		width: 50px;
		height: 50px;
		cursor: pointer;
	}

	.goto_index .qwe_warp>div {
		width: 60px;
		color: #ffffff;
		font-size: 14px;
	}

	.goto_index .qwe_warp>img {
		width: 100%;
		height: 100%;
	}

	.toIndex {
		display: inline-block;
		position: absolute;
		bottom: 20px;
		color: #fff;
		margin-left: 35%;
		text-decoration: none;
		background-color: #691d1d;
		padding: 8px 18px;
		border-radius: 8px;
	}

	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(0, 0, 0, 0.6);
	}

	.ewm_warp {
		position: absolute;
		top: 50%;
		left: 50%;
		margin-left: -200px;
		margin-top: -150px;
		width: 400px;
		height: 300px;
	}

	.ewm_img {
		width: 200px;
		height: 200px;
		margin-left: 100px;
		margin-top: 10px;
		background-color: #fff;
		padding: 6px;

	}

	.ewm_img img {
		width: 100%;
		height: 100%;
	}

	.ewm_warp .btn_div {
		position: absolute;
		bottom: 20px;
		border: 1px solid #fff;
		color: #fff;
		padding: 8px 20px;
		cursor: pointer;
	}

	.btn_div1 {
		left: 10px;
	}

	.btn_div2 {
		left: 150px;
	}

	.btn_div3 {
		left: 290px
	}

	.sq_ewm {
		position: absolute;
		top: 50%;
		left: 50%;
		margin-left: -250px;
		margin-top: -300px;
		width: 500px;
		background-color: #fff;
		border-radius: 10px;
		overflow: hidden;
		z-index: 9999;
	}

	.sq_ewm .sq_ewm_title {
		height: 60px;
		background-color: #e90e0e;
		color: #fff;
		text-align: center;
		line-height: 60px;
		font-size: 20px;
		letter-spacing: 6px;
	}

	.sq_ewm .gb_sqewm {
		position: absolute;
		top: 10px;
		right: 10px;
		cursor: pointer;
		width: 20px;
		height: 20px;
		background-color: #ca0e0e;
	}

	.sq_ewm .gb_sqewm>img {
		width: 100%;
		height: 100%;
	}

	.sq_ewm .from_sq {
		width: 80%;
		margin: 30px auto;
	}

	/deep/ .el-form-item__label {
		font-size: 16px;
	}

	/deep/ .el-form-item {
		margin-bottom: 10px;
	}

	/deep/ .dwmc_warp label {
		letter-spacing: 4px;
	}

	/deep/ .zw_warp {
		letter-spacing: 30px;
	}

	/deep/ .lxr_warp {
		letter-spacing: 14px;
	}

	/deep/ .search_sty_input input {
		border: #ca151e 2px solid;
		height: 40px;
		line-height: 40px;
		border-right: none;
	}

	.ckgd_dh {
		float: left;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}

	.ckgd_dh>div>img {
		width: 100%;
		height: 100%;
	}

	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;

	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}
</style>
